import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralLevelsComponent } from '@common/config/ReferralsLevels';
import { FriendsTable } from '@components/Partners/FriendsTable/FriendsTable';
import { Tab } from '@components/Tabs/Tab';
import { Tabs } from '@components/Tabs/Tabs';
import { TabsNavigation } from '@components/Tabs/TabsNavigation';
import { H1 } from '@components/Typography/Typography';
import { Close } from '@components/ui/Close/Close';

import { BackgroundWrapper } from '@/components/ui/BackgroundWrapper/BackgroundWrapper';

import { ModalContext } from '../Modal/config';

import css from './styles.module.scss';

const FriendsModal: FC = () => {
  const { closeModal } = useContext(ModalContext);
  const { t } = useTranslation();
  const referralLevels = ReferralLevelsComponent();

  return (
    <div className="relative w-full overflow-y-auto pt-[1.875rem] px-4">
      <Close
        onClick={closeModal}
        className="absolute right-4 top-4 z-20"
        imageVariant="modal"
        variant="modal"
      />
      <BackgroundWrapper className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-t-2xl">
        <div className={css.effect}></div>
        <div className={css.gradient}></div>
      </BackgroundWrapper>
      <div className="relative z-10 flex flex-col items-center h-full">
        <H1 weight="bold" className="mb-[1.875rem]">
          {t('Friends list')}
        </H1>
        <Tabs initActiveTab="1">
          <TabsNavigation list={referralLevels} />
          <Tab tabId="1" className="flex-1">
            <FriendsTable level={1} />
          </Tab>
          <Tab tabId="2" className="flex-1">
            <FriendsTable level={2} />
          </Tab>
          <Tab tabId="3" className="flex-1">
            <FriendsTable level={3} />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export { FriendsModal };
